export const PICKLEJAR_DEFAULT_LOGIN_URL = '/login';
export const PICKLEJAR_DEFAULT_PROFILE_PAGE_URL = '/profile';
export const PICKLEJAR_DEFAULT_ID_VERIFY_PAGE_URL = '/verify-id';
export const PICKLEJAR_DEFAULT_GO_BACK_PROFILE_PAGE_URL = PICKLEJAR_DEFAULT_PROFILE_PAGE_URL;
